import cx from 'classnames';
import { showModal } from 'modal.react.js';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import Divider from 'components/shared/Divider';
import area from 'components/shared/GlobalModalArea/area';
import AlertModal from 'components/shared/GlobalModalArea/Modal/AlertModal';
import { SyncCalendar } from 'components/shared/SyncCalendar';
import { history as storeHistory } from 'configureStore';
import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { itinerariesItemDataSelector, itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';
import { useItinerariesItemStepPath } from 'utils/itineraries/functions/useItinerariesItemStepPath';
import { ITINERARY_STEPS } from 'utils/itineraries/itinerary/map';

import { useBlockContext } from '../../Block/context';
import s from './index.module.css';
import TravelBriefTable from './TravelBriefTable';

function Overview({ showDivider }: { showDivider?: boolean }) {
  const handleClick = useShowNavigationModal();
  const scheduleType = useSelector(itineraryScheduleTypeSelector);
  const isSyncCalendarVisible = scheduleType === 'dates';

  return (
    <div>
      {isSyncCalendarVisible && <SyncCalendar />}
      <div className={cx(s.wrapper, 'custom-overview-wrapper')} onClick={() => handleClick()}>
        <TravelBriefTable />
        {showDivider && <Divider />}
      </div>
    </div>
  );
}

export const useShowNavigationModal = () => {
  const { readonly } = useBlockContext();
  const history = useHistory();
  const proposal = useSelector(itinerariesItemDataSelector);
  const getStepPath = useItinerariesItemStepPath(ITINERARIES_ITEM_TYPES.ITINERARY);

  const handleClick = (activeEventId?: number) => {
    const stepPath = getStepPath(
      ITINERARY_STEPS.DETAILS,
      proposal.type === 'itinerary' ? proposal?.id : proposal?.itinerary?.id,
      {},
      activeEventId ? { activeTripEventId: activeEventId } : {},
    );

    if (readonly) return;

    showModal(area, (res) => {
      const unregister = storeHistory.listen(() => res());
      const handleClose = () => {
        res();
        unregister();
      };

      return (
        <AlertModal
          headerText="Heads Up!"
          confirmButtonText="Yes, Go"
          closeButtonText="Cancel"
          res={res}
          onAccept={() => {
            history.push(stepPath);
            handleClose();
          }}
          bodyText={
            <>
              Edits to this page can only be done in the Details Tab. <br /> Do you want to go there now?
            </>
          }
        />
      );
    });
  };

  return handleClick;
};

export default Overview;
